






































import Vue from "vue";
import { VueLoading } from "vue-loading-template";
import { showNotifyDialog } from "@/lib/dialog";
import { compareAsc, format } from "date-fns";
import ja from "date-fns/locale/ja";
import isMobile from "ismobilejs";
import axiosBase from "axios";

const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    VueLoading,
  },
  props: {
    id: String,
  },
  async created() {
    const { id } = this;

    const contestRequest = await axios.get(`/contest/${id}`);
    if (contestRequest.status !== 200) {
      await showNotifyDialog({
        title: "エラー",
        content: "コンテスト情報の取得に失敗しました。",
      });
    }
    this.contest = contestRequest.data;
    this.isLoading = false;
  },
  data() {
    return {
      isLoading: true,
      contest: {},
    };
  },
  computed: {
    contestId() {
      const { contest } = this;
      return contest.contestId;
    },
    title() {
      const { contest } = this;
      return contest.contest;
    },
    department() {
      const { contest } = this;
      return contest.department;
    },
    free() {
      const { contest } = this;
      return contest.free;
    },
    image() {
      const { contest } = this;
      return contest.image.url;
    },
    referenceSource() {
      const { contest } = this;
      return contest.referenceSource;
    },
    deadline() {
      const { contest } = this;
      const { deadline } = contest;

      if (!deadline) return "-";

      return format(deadline, "YYYY/MM/DD（dd） HH:mm", { locale: ja });
    },
    genre() {
      const { contest } = this;
      return contest.genre;
    },
    category() {
      const { contest } = this;
      return contest.category;
    },
    award() {
      const { contest } = this;
      return contest.award;
    },
    content() {
      const { contest } = this;
      return contest.content;
    },
    homepage() {
      const { contest } = this;
      return contest.homepage;
    },
    entryForm() {
      const { contest } = this;
      return contest.entryForm;
    },
    isAnyMobile() {
      return isMobile().any;
    },
    width() {
      const { isAnyMobile } = this;
      return isAnyMobile ? "100%" : "auto";
    },
    height() {
      const { isAnyMobile } = this;
      return isAnyMobile ? "auto" : "300";
    },
    isExpired() {
      const { contest } = this;
      const { deadline } = contest;

      if (!deadline) return false;

      const currentDate = format(new Date(), "YYYY-MM-DD");
      const contestDeadline = format(deadline, "YYYY-MM-DD");

      return compareAsc(currentDate, contestDeadline) === 1;
    },
  },
  methods: {
    onClickHomepage() {
      const { homepage } = this;
      window.open(homepage);
    },
    onClickEntry() {
      const { id, contestId, entryForm } = this;
      if (contestId) this.$router.push({ name: "eventContestEntry", params: { id, contestId } });
      else window.open(entryForm);
    },
    onClickBack() {
      const { $router } = this;
      $router.back();
    },
    onClickBackContestList() {
      const { $router } = this;
      $router.push({ name: "eventContest" });
    },
  },
  watch: {
    contestId(value) {
      if (value) this.$store.dispatch("nolaContestModule/fetchContest", this.contestId);
    },
  },
});

interface Props {
  id: string;
}

interface Data {
  isLoading: boolean;
  contest: Contest;
}

interface Computed {
  contestId?: string;
  title: string;
  department: string;
  free: string;
  image?: string;
  referenceSource: string;
  deadline: string;
  genre: string;
  category: string;
  award: string;
  content: string;
  homepage: string;
  entryForm: string;
  isAnyMobile: boolean;
  width: string;
  height: string;
  isExpired: boolean;
}

interface Methods {
  onClickHomepage(): void;
  onClickEntry(): void;
  onClickBack(): void;
  onClickBackContestList(): void;
}

type Contest = {
  [key: string]: any;
};
